import { gsap } from "gsap";

export function fade() {
const messageTtl = document.querySelector('.message-ttl');
const messageTxt = document.querySelector('.message-txt');

const TL = gsap.timeline();
TL.to(messageTtl, { Y: 100, duration: 1 })
  .to(messageTxt, { Y: 100, duration: 1 })
}